export const GENDER_DEFAULT_VALUE = 'All Genders'
export const RACE_DEFAULT_VALUE = 'All Races'
export const INDUSTRY_DEFAULT_VALUE = 'All Industries'

export type States = 'default' | 'generating' | 'generated' | 'error'
